import React from 'react';

import { Button } from 'antd';

import { ModalBullet } from '../ModalBullet';
import { StartTrialButton } from '../StartTrialButton';
import proLogo from '../../../../../../assets/sightxProLogoBlack.png';

import styles from './index.module.scss';

const BULLETS = [
  'Try out Pro features for 14 days',
  'Guided walkthroughs of upgrade features',
  'No credit card needed!'
];

interface IProTrialContentProps {
  onCancel: () => void;
  onClose: () => void;
}

export const ProTrialContent: React.FunctionComponent<IProTrialContentProps> = ({ onCancel, onClose }) => {
  return (
    <section className={styles.container}>
      <img src={proLogo} alt="sightx-pro-logo" className={styles.logo} />
      <h1>Start your free trial of SightX Pro!</h1>
      <h2>Not sure if Pro is right for you? Try it for free!</h2>
      <div className={styles.content}>
        {BULLETS.map((bullet, index) => (
          <ModalBullet key={`${bullet}-${index}`} content={bullet} />
        ))}
      </div>
      <div className={styles.actions}>
        <Button
          type="default"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <StartTrialButton onClose={onClose} />
      </div>
    </section>
  );
};